export default function isSignedPixelData(frameInfo) {
    const declaredSigned = frameInfo?.isSigned === true || frameInfo?.isSigned === 1;
    return declaredSigned && frameInfo.componentCount === 1;
}
